import type { IconProps } from '../types/IconProps.ts';
export const Check: IconProps = {
    name: 'Check',
    children: [
        `<path d="m4 11.61 5.28 5.24c.2.2.55.2.75 0L20 6" />`,
    ]
};